import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import styled from 'styled-components'
import Section from '../../../Utilitis/Section'
import Teacher from '../../../Utilitis/Teacher/Teacher'
import TitleSection from '../../../Utilitis/TitleSection'
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';


export default function OurTeachers(props) {
    const options_OwlCarousel = {
        margin: 30,
        responsiveClass: true,
        nav: false,
        autoplay: true,
        smartSpeed: 1000,
        responsive: {
            0: {
                items: 1,
            },
            400: {
                items: 2,
            },
            600: {
                items: 2,
            },
            760: {
                items: 3,
            },
            1000: {
                items: 4,
            }
        },
    };

    return (
        <Section bg="white">
            <Container>
                <TitleSection text="Our Teachrs" center title />
                <OwlCarousel className='owl-theme' {...options_OwlCarousel}   >
                    <div className='item'> <Teacher image="\images\pexels-max-fischer-5212317.jpg" name="Micle Jackarim" /> </div>
                    <div className='item'> <Teacher image="\images\icons8-team-FcLyt7lW5wg-unsplash.jpg" name="Jhone Jack" /> </div>
                    <div className='item'> <Teacher image="\images\fabio-lucas-32co88SaiN4-unsplash.jpg" name="Brown Milk" /> </div>
                    <div className='item'> <Teacher image="\images\teacher_1.jpg" name="Bato David" /></div>
                    <div className='item'>  <Teacher image="\images\pexels-max-fischer-5212317.jpg" name="Micle Jackarim" /></div>
                </OwlCarousel>;
            </Container>
        </Section>
    )
}
